import { atom } from 'jotai';

import type { AdultTreatmentKey } from '../patientEducationDialog/AdultTabs';
import type { PediatricTreatmentKey } from '../patientEducationDialog/PediatricTabs';
import type { ImageObject } from '../types';

export type TFindingBounds = {
  id?: string;
  xMin?: number;
  yMin?: number;
  xMax?: number;
  yMax?: number;
  x?: number;
  y?: number;
  type?: string;
  tooth?: string | number;
};

export type TAnnotateActions = 'segment' | 'circle' | 'arrow' | undefined;

export const casePresentationModeAtom = atom<boolean>(false);
export const selectedFindingsAtom = atom<TFindingBounds | undefined>(undefined);
export const selectedFindingImageIdAtom = atom<string | undefined>(undefined);
export const disableKeyPressAtom = atom<boolean>(false);
export const annotateActionAtom = atom<TAnnotateActions>(undefined);
export const deleteUserAnnotationAtom = atom<boolean>(false);
export const hiddenAnnotationsAtom = atom<string[]>([]);
export const selectedAnnotationAtom = atom<{
  selectedAnnotation: string;
  coordinates?: [string, string];
  activeImage?: ImageObject;
}>({
  selectedAnnotation: '',
});
export const activeImageIsSelectedAtom = atom<boolean>(true);
export const selectedTeethPreviewAtom = atom<string[]>([]);
export const patientDownloadableNotesAtom = atom<string>('');
export const patientDownloadableSelectedTreatmentsAtom = atom<
  (AdultTreatmentKey | PediatricTreatmentKey)[]
>([]);
